export default {
  renewal_date_override:"Renewal date override",
  membership_term_start:"Membership term start",
  joined_at:"Joining date",
  billingFrequency:"Billing frequency",
  contractMonths:"Contract duration (months, 1–120)",
  billingOptions:"Billing Options",
  accountHelp:"Allow eligible purchases to be charged to the configured responsible account.",
  duesHelp:"Enrol membership dues in recurring billing. Membership remains attached to this member.",
  initiationHelp:"Include the initiation fee once in the applicable billing cycle.",

  accountCharging:"Can charge to account",
  duesEnrolment:"Enrol into recurring billing and add member dues",
  initiationFee:"Include initiation fee in recurring bill cycle",
  feesHelp:"Dues and initiation fees use the responsible account. Disabling discretionary account charging does not cancel dues enrolment.",
  status_open:"Open",
  status_paid:"Paid",
  status_partially_settled:"Partially settled",
  status_partially_paid:"Partially paid",
  status_pending:"Pending",
  status_overdue:"Overdue",
  status_void:"Void",
  status_refunded:"Refunded",
  status_reversed:"Reversed",
  status_cancelled:"Cancelled",
  status_posted:"Posted",
  status_invoiced:"Invoiced",
  status_settled:"Settled",
  status_written_off:"Written off",
  status_unknown:"Status unavailable",

  billing_option_invalid:"Billing options must be enabled or disabled.",
  billing_payer_invalid:"Select a valid member as account payer.",
  "category": "Member category",
  "adult": "Adult",
  "child": "Child",
  "unclassified": "Unclassified (legacy)",
  "requirePayer": "Require another member as account payer",
  "thisMember": "This Member",
  "anotherMember": "Another Member",
  "accountPayer": "Account payer",
  "search": "Search member name or membership number",
  "summary": "{member}’s eligible account charges will be billed to {payer}’s account.",
  "billedTo": "Billed to {payer}",
  "forMember": "For {member}",
  "chargeAccount": "Charge {payer}’s account · For {member}",
  "linkedCharges": "Charges billed to another member",
  "searching": "Searching members…",
  "typeToSearch": "Type at least 2 characters to search.",
  "noResults": "No members found.",
  "billing_forbidden": "You need permission to change billing responsibility.",
  "billing_member_not_found": "The member or payer does not belong to this club.",
  "billing_member_inactive": "The service member is inactive.",
  "billing_account_charging_disabled": "Account charging is disabled for this member. Choose cash/card or ask staff to enable it.",
  "billing_another_payer_required": "This membership type requires another account payer. Select an eligible member.",
  "billing_payer_required": "Select an eligible account payer before enabling account billing.",
  "billing_override_forbidden": "You cannot override the configured payer.",
  "billing_payer_inactive": "The payer is inactive. Select another eligible payer.",
  "billing_payer_chain": "A payer must use their own account and cannot redirect charges to another member.",
  "billing_payer_ineligible": "The payer must have account charging enabled and an eligible account.",
  "billing_account_ineligible": "The responsible account is missing or inactive. Ask staff to configure an eligible account.",
  "billing_credit_limit": "This charge exceeds the responsible account’s credit limit. Choose cash/card or contact staff.",
  "billing_mode_invalid": "Choose This Member or Another Member.",
  "billing_payer_self": "Choose This Member to use your own account.",
  "billing_policy_changed": "Billing settings changed. Reload the member before saving.",
  "billing_category_required": "Select Adult or Child for a new membership type.",
  "billing_category_invalid": "Select a valid member category.",
  "billing_requirement_invalid": "Select a valid payer requirement."
};
